var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTenge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 442.000000 600.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,600.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 5685 l0 -315 2210 0 2210 0 0 315 0 315 -2210 0 -2210 0 0 -315z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 4735 l0 -315 945 0 945 0 0 -2210 0 -2210 320 0 320 0 0 2210 0 2210 945 0 945 0 0 315 0 315 -2210 0 -2210 0 0 -315z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenge);
export default __webpack_public_path__ + "static/media/tenge.ac0fda799552b30f4c2f989025ef1fb4.svg";
export { ForwardRef as ReactComponent };